export enum ENoImageSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}
